/* eslint-disable no-underscore-dangle */
import React from 'react';
import moment from 'moment';
import PropTypes, { any } from 'prop-types';

import Filter, { FilterModal, FilterSection } from './Filter';
import DateFilter, { IN_PROGRESS_EVENTS_DATE } from './FilterComponents/DateFilter';

import styles from '../search.scss';

const EventDateFilter = (props) => {
    const { filters, filterInputs, handleFilterClick, filterModal, closeModals, handleFilterSubmit, handleFilterUpdate, mobileOnly, desktopOnly, customDateSelectOptions, minDate, maxDate, onlyCustom, 'data-testid': dataTestId } = props;

    const dateButtonLabel = () => {
        // eslint-disable-next-line no-shadow
        const { startDate, endDate } = filters;
        const momentStartDate = moment(startDate);
        const momentEndDate = moment(endDate);

        let label = `${(startDate && moment(startDate).format('MM/DD/YY')) || '...'} - ${(endDate && moment(endDate).format('MM/DD/YY')) || '...'}`;
        if (!onlyCustom) {
            if (startDate && startDate._isAMomentObject) {
                if (momentStartDate.isSame(IN_PROGRESS_EVENTS_DATE, 'day')) {
                    label = 'In Progress Events';
                }
                if (momentStartDate.isSame(moment(), 'days')) {
                    if (!(endDate && endDate._isAMomentObject)) {
                        label = 'Upcoming Events';
                    }
                }
            }
            if (endDate && endDate._isAMomentObject && momentEndDate.isSame(moment().subtract(1, 'days'), 'day')) {
                label = 'Past Events';
            }
        }

        return label;
    };

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={'date'}
                handleFilterClick={handleFilterClick}
                isActive={(filters && (filters.startDate || filters.endDate)) || filterModal === 'date'}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                {(filters && (filters.startDate || filters.endDate)) ? dateButtonLabel() : 'Date Range'}
            </Filter>
            {filterModal === 'date' && (
                <FilterModal
                    title={'Date Range'}
                    handleFilterSubmit={handleFilterSubmit}
                    onCloseClick={closeModals}
                    data-testid={dataTestId}
                >
                    <FilterSection data-testid={dataTestId && `${dataTestId}.body`}>
                        <DateFilter
                            customDateSelectOptions={customDateSelectOptions}
                            startDate={filterInputs.startDate}
                            endDate={filterInputs.endDate}
                            fromDateChange={(momentObj) => { handleFilterUpdate({ startDate: momentObj }); }}
                            toDateChange={(momentObj) => {
                                handleFilterUpdate({ endDate: momentObj });
                            }}
                            handleFilterUpdate={handleFilterUpdate}
                            minDate={minDate}
                            maxDate={maxDate}
                            onlyCustom={onlyCustom}
                            data-testid={dataTestId && `${dataTestId}.date-filter`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

EventDateFilter.propTypes = {
    filters: PropTypes.shape({
        startDate: PropTypes.shape({
            _isAMomentObject: PropTypes.bool,
        }),
        endDate: PropTypes.shape({
            _isAMomentObject: PropTypes.bool,
        }),
    }),
    filterInputs: PropTypes.objectOf(any),
    handleFilterClick: PropTypes.func,
    filterModal: PropTypes.string,
    closeModals: PropTypes.func,
    handleFilterSubmit: PropTypes.func,
    handleFilterUpdate: PropTypes.func,
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
    customDateSelectOptions: PropTypes.arrayOf(PropTypes.shape),
    maxDate: PropTypes.objectOf(any).isRequired,
    minDate: PropTypes.objectOf(any).isRequired,
    onlyCustom: PropTypes.bool,
    'data-testid': PropTypes.string,
};

EventDateFilter.defaultProps = {
    filters: {
        startDate: moment().subtract(2, 'year'),
        endDate: moment(),
    },
    filterInputs: {},
    handleFilterClick: () => {},
    filterModal: 'date',
    closeModals: () => {},
    handleFilterSubmit: () => {},
    handleFilterUpdate: () => {},
    mobileOnly: false,
    desktopOnly: true,
    customDateSelectOptions: null,
    onlyCustom: false,
    'data-testid': undefined,
};

export default EventDateFilter;
